import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { propValidationConfig } from './propValidationConfig';
export const ProgressBar = /*#__PURE__*/forwardRef(({
  label = '',
  completedPercent = 0
}) => {
  const completedPercentWidth = Math.min(Math.max(completedPercent, 0), 100);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(ProgressBarContainer, null, /*#__PURE__*/React.createElement(StyledProgressBar, {
    width: completedPercentWidth
  })));
});
export default ProgressBar;
const Container = styled.div.withConfig({
  displayName: "progressBar__Container",
  componentId: "sc-d690a4-0"
})(["height:48px;"]);
const ProgressBarContainer = styled.div.withConfig({
  displayName: "progressBar__ProgressBarContainer",
  componentId: "sc-d690a4-1"
})(["margin-top:", ";width:100%;height:", ";background-color:", ";"], spacing.space16, spacing.space4, nafColor.neutral.neutral3);
const StyledProgressBar = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "progressBar__StyledProgressBar",
  componentId: "sc-d690a4-2"
})(["width:", "%;height:", ";background-color:", ";"], props => props.width, spacing.space4, nafColor.primary.park);
const Label = styled.label.withConfig({
  displayName: "progressBar__Label",
  componentId: "sc-d690a4-3"
})(["font-size:18px;font-style:normal;font-weight:700;line-height:28px;"]);
//# sourceMappingURL=progressBar.js.map